
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Firebase configuration for development
// In production, this would be handled securely through environment variables
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDqNccTFxWtsiaME_dGKdgZYlplaisg5Sw",
  authDomain: "svennis-platform-prod.firebaseapp.com",
  projectId: "svennis-platform-prod",
  storageBucket: "svennis-platform-prod.firebasestorage.app",
  messagingSenderId: "395278498047",
  appId: "1:395278498047:web:b9f48d23ea264c1a30b4ca"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Connect to Firebase Auth Emulator in development
if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, 'http://localhost:29099');
}

export default app;